import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive'
import { toast, ToastContainer } from 'react-toastify';
import Turnstile from './Turnstile';

// Unset in local development; the api skips the check when its secret is unset too.
const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

function ContactPage() {
    const isXL = useMediaQuery({ query: '(min-width: 1824px)' });
    const isLG = useMediaQuery({ query: '(min-width: 1224px)' }) && !isXL;
    const isMD = useMediaQuery({ query: '(min-width: 768px)' }) && !isLG && !isXL;
    const isSM = useMediaQuery({ query: '(min-width: 425px)' }) && !isMD && !isLG && !isXL;
    const isXS = useMediaQuery({ query: '(max-width: 425px)' });
    const [loading, setLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [turnstileToken, setTurnstileToken] = useState(null);
    const turnstileRef = useRef(null);
    const MAX_FILES = 5;

    const { formatMessage, locale } = useIntl();
    const { getRootProps, getInputProps } = useDropzone({
        multiple: true,
        maxFiles: MAX_FILES,
        onDrop: (acceptedFiles, fileRejections) => {
            console.log(acceptedFiles);
            setUploadedFiles((prevFiles) => {
                const previous = prevFiles || [];
                let combined = [...previous, ...acceptedFiles];

                if (combined.length > MAX_FILES) {
                    combined = combined.slice(0, MAX_FILES);
                    toast.error(
                        formatMessage({ id: "max_5_files_allowed" }) || "En fazla 5 dosya seçebilirsiniz."
                    );
                }

                return combined;
            });
            if (fileRejections && fileRejections.length > 0) {
                const tooManyFiles = fileRejections.some(rej =>
                    rej.errors.some(err => err.code === "too-many-files")
                );
                if (tooManyFiles) {
                    toast.error(
                        formatMessage({ id: "max_5_files_allowed" }) || "En fazla 5 dosya seçebilirsiniz."
                    );
                }
            }
        }
    });


    const handleFormSubmit = async (e) => {
        console.log(loading)
        if (!loading) {
            e.preventDefault();
            if (TURNSTILE_SITE_KEY && !turnstileToken) {
                toast.error(formatMessage({ id: "captcha_required" }));
                return;
            }
            setLoading(true);
            const formData = new FormData(e.target);
            const data = {
                fullname: formData.get('name'),
                email: formData.get('email'),
                title: formData.get('title'),
                message: formData.get('message'),
                sent_from: "website",
                homepage: formData.get('homepage'),
                turnstile_token: turnstileToken
            }
            if (uploadedFiles?.length > 0) {
                const filesFormData = new FormData();
                uploadedFiles.forEach(file => {
                    filesFormData.append("contactMessageContents", file);
                });
                await axios.post(`${process.env.REACT_APP_API_URL}contactMessage/uploadContactMessageContents`, filesFormData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).catch((err) => {
                    console.log("err: " + err);
                }).then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        data.contactMessageContents = response.data.contentPaths.map((contentPath, index) => { return { content_path: contentPath, original_name: response.data.originalFileNames[index] } });
                    }
                });
            }
            await axios.post(`${process.env.REACT_APP_API_URL}contactMessage/createContactMessage`, {
                ...data
            })
                .catch((err) => {
                    console.log("err: " + err);
                    toast.error(formatMessage({ id: "send_failed" }));
                    setLoading(false);
                })
                .then((response) => {
                    // The token is single-use, so a fresh challenge is needed for any next attempt.
                    turnstileRef.current?.reset();
                    if (response && response.data.success === true && response.data.status === 201) {
                        //reset form
                        e.target.reset();
                        setUploadedFiles(null);
                        toast.success(formatMessage({ id: "message_sent_success" }));
                        setLoading(false);
                    }
                });
        }
    }

    return (
        <div>
            {(isXL || isLG || isMD) &&
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        padding: "97px 0 97px 0",
                        backgroundImage: "url('assets/images/background.png')",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "fixed",
                        backgroundSize: "cover",
                    }}>
                    <h1 style={{
                        textAlign: "center",
                        fontWeight: "700",
                        fontSize: "40px",
                        color: "white",
                        marginTop: 0
                    }}>
                        <FormattedMessage id="contact_us" />
                    </h1>
                </div>
            }
            <div style={{
                padding: (isSM || isXS) ? "70px 50px" : "100px 180px",
                backgroundColor: "white",
                color: "#212121"
            }}>
                <h1 style={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "40px",
                    marginTop: 0
                }}>
                    <FormattedMessage id="leave_us_a_message" />
                </h1>
                <div>
                    <form
                        onSubmit={handleFormSubmit}
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                            maxWidth: "860px",
                            margin: "auto",
                            gap: "20px"
                        }}>
                        <InputField
                            inputProps={{
                                id: "name",
                                type: "text",
                                placeholder: formatMessage({ id: "full_name" }),
                                required: true,
                            }}
                            containerProps={{
                                gridColumn: (isSM || isXS) ? "span 2" : "span 1",
                            }}
                        />
                        <InputField
                            inputProps={{
                                id: "email",
                                type: "email",
                                placeholder: formatMessage({ id: "email" }),
                                required: true,
                            }}
                            containerProps={{
                                gridColumn: (isSM || isXS) ? "span 2" : "span 1",
                            }}
                        />

                        <InputField
                            inputProps={{
                                id: "title",
                                type: "text",
                                placeholder: formatMessage({ id: "subject" }),
                                required: true,
                            }}
                            containerProps={{
                                gridColumn: "span 2",
                            }}
                        />

                        <InputField
                            inputProps={{
                                id: "message",
                                type: "text",
                                placeholder: formatMessage({ id: "message" }),
                                required: true,
                                rows: 4
                            }}
                            containerProps={{
                                gridColumn: "span 2",
                            }}
                            textarea
                        />

                        <div style={{
                            gridColumn: "span 2",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            fontSize: "14px",
                            fontWeight: "600",
                        }}>
                            <div {...getRootProps({ className: "dropzone" })} style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                                padding: "70px 20px",
                                backgroundColor: "#F2EBFF",
                                border: "2px dashed #8C52FF",
                                borderRadius: "12px",
                                cursor: "pointer"
                            }}>
                                <input {...getInputProps()} />
                                <p style={{ margin: 0, color: "#8C52FF", textAlign: "center" }}>
                                    <FormattedMessage id="clict_to_select_files_optional" />
                                </p>
                            </div>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                            }}>
                                {!!uploadedFiles &&
                                    uploadedFiles.map((uploadedFile, index) =>
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "8px 16px",
                                                backgroundColor: "#1C1C1C10",
                                                borderRadius: "12px"
                                            }}>
                                            <p style={{ margin: 0, color: "#8C52FF", userSelect: "none", maxWidth: "80%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{uploadedFile.name}</p>
                                            <img src="/assets/images/close.png" alt="close" style={{ height: "24px", cursor: "pointer", userSelect: "none" }} onClick={() => {
                                                setUploadedFiles(uploadedFiles.filter((file, i) => i !== index))
                                            }} />
                                        </div>
                                    )
                                }
                            </div>
                        </div>

                        {/* Honeypot: hidden from people, filled in by form bots. */}
                        <input
                            type="text"
                            name="homepage"
                            tabIndex={-1}
                            autoComplete="off"
                            aria-hidden="true"
                            style={{ position: "absolute", left: "-10000px", width: "1px", height: "1px", overflow: "hidden" }}
                        />

                        {TURNSTILE_SITE_KEY &&
                            <div style={{ gridColumn: "span 2", display: "flex", justifyContent: "center" }}>
                                <Turnstile
                                    ref={turnstileRef}
                                    siteKey={TURNSTILE_SITE_KEY}
                                    language={locale}
                                    onTokenChange={setTurnstileToken}
                                />
                            </div>
                        }

                        <button style={{
                            background: "#8C52FF",
                            padding: "16px 24px",
                            textAlign: "center",
                            border: "none",
                            gridColumn: "span 2"
                        }} className={'rounded16 app-button'} >
                            <p style={{ fontSize: "18px", margin: 0, color: "white", userSelect: "none" }}>
                                <FormattedMessage id="send" />
                            </p>
                        </button>

                    </form>
                </div>
            </div>
            <ToastContainer position="bottom-right" autoClose={1500} theme="colored" limit={1} />
        </div>
    )
}

function InputField({ containerProps, inputProps, textarea }) {
    const { formatMessage } = useIntl();
    const Input = textarea ? 'textarea' : 'input';
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                fontSize: '14px',
                fontWeight: '600',
                ...(containerProps ? containerProps : {})
            }}
        >
            <Input
                {...inputProps}
                name={inputProps?.name || inputProps?.id}
                onInvalid={(e) => {
                    if (e.target.validity.valueMissing) {
                        e.target.setCustomValidity(formatMessage({ id: "this_field_cannot_be_empty" }));
                    } else if (e.target.validity.typeMismatch || (inputProps?.type === 'email' && e.target.validity.patternMismatch)) {
                        e.target.setCustomValidity(formatMessage({ id: "please_enter_a_valid_email" }));
                    } else {
                        e.target.setCustomValidity("");
                    }
                }}
                onChange={(e) => {
                    inputProps?.onChange && inputProps.onChange(e);
                    if (e.target.validity.valueMissing) {
                        e.target.setCustomValidity(formatMessage({ id: "this_field_cannot_be_empty" }));
                    } else if (e.target.validity.typeMismatch || (inputProps?.type === 'email' && e.target.validity.patternMismatch)) {
                        e.target.setCustomValidity(formatMessage({ id: "please_enter_a_valid_email" }));
                    } else {
                        e.target.setCustomValidity("");
                    }
                }}
                style={{
                    borderColor: '#1C1C1C10',
                    backgroundColor: 'white',
                    borderWidth: '2px',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    placeholderTextColor: '#9ca3af',
                }}
            />
        </div>
    );


}


export default ContactPage